import type { IconSvgObject } from './types';

const HandPointingRight04Icon: IconSvgObject = [
  ["path", { d: "M11.6454 14H13.5C14.3284 14 15 13.3284 15 12.5V11M11 17H12.5C13.3284 17 14 16.3284 14 15.5V14.2328M15 11L12.5789 11M10 8L15 8H20C20.8284 8 21.5 8.67157 21.5 9.5C21.5 10.3284 20.8284 11 20 11H15M13 17.3237V18.5C13 19.3284 12.3284 20 11.5 20H5.5C3.84315 20 2.5 18.6569 2.5 17L2.5 9.60555C2.5 8.60249 3.0013 7.6658 3.8359 7.1094L7.74423 4.50385C8.23703 4.17531 8.81605 4 9.40833 4L9.75736 4C10.553 4 11.3161 4.31607 11.8787 4.87868L15 8", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default HandPointingRight04Icon;
